/* eslint-disable jsx-a11y/no-distracting-elements */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect, useMemo } from "react";
import Carousel from "react-bootstrap/Carousel";
import { Container, Row, Col, Card, Button, Badge } from "react-bootstrap";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

import web from "../img/hotel.jpg";
import web1 from "../img/hospital.jpg";
import web2 from "../img/teagarden.jpg";
import web3 from "../img/jwl.jpg";
import web4 from "../img/rest.jpg";
import web5 from "../img/ak1.png";
import web6 from "../img/ak2.png";

const Home = () => {
  // ===================== BRAND + SEO CONFIG =====================
  const brand = useMemo(
    () => ({
      name: "EBS Software Solution",
      email: "info@ebssoftware.co.in",
      phoneTop: "+91 99320 13501",
      salesPhone: "+91 97337 2 1111",
      gst: "19AJAPM8399K1ZE",
      websiteUrl: "https://example.com", // ✅ replace with your real website
      pageUrl: "https://example.com/", // ✅ replace with your live home URL
    }),
    []
  );

  const seo = useMemo(
    () => ({
      title: "EBS Software Solution | ERP, GST Billing, POS & Industry Software India",
      description:
        "EBS Software Solution (Siliguri, West Bengal, India) provides customized ERP, GST billing, POS and industry software for Tea Garden, Hotel, Hospital, Jewellery, Restaurant and Retail—with implementation, training and support.",
      keywords:
        "EBS Software Solution, ERP software India, GST billing software, POS software, Hotel management software, Hospital management software, Tea garden ERP, Jewellery billing software, Restaurant POS, Siliguri software company",
    }),
    []
  );

  // ===================== THEME =====================
  const theme = useMemo(
    () => ({
      bg: "#0b1220",
      surface: "rgba(255,255,255,0.06)",
      border: "rgba(255,255,255,0.12)",
      ink: "#ffffff",
      text: "rgba(255,255,255,0.82)",
      muted: "rgba(255,255,255,0.70)",
      accent: "#ff6a00",
      accent2: "#ff3d00",
      glow1: "rgba(255,106,0,0.20)",
      glow2: "rgba(56,189,248,0.15)",
      shadow: "0 18px 55px rgba(0,0,0,0.35)",
      softShadow: "0 14px 40px rgba(0,0,0,0.28)",
    }),
    []
  );

  // ===================== SEO META + JSON-LD (NO Helmet) =====================
  const schemaMarkup = useMemo(
    () => ({
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Organization",
          name: brand.name,
          url: brand.websiteUrl,
          email: brand.email,
          telephone: brand.salesPhone,
        },
        {
          "@type": "WebSite",
          name: brand.name,
          url: brand.websiteUrl,
        },
        {
          "@type": "WebPage",
          "@id": brand.pageUrl,
          url: brand.pageUrl,
          name: seo.title,
          description: seo.description,
        },
      ],
    }),
    [brand, seo]
  );

  useEffect(() => {
    const prevTitle = document.title;
    document.title = seo.title;

    const head = document.head;
    const cleanup = () => {
      head.querySelectorAll('[data-ebs-home="1"]').forEach((n) => n.remove());
    };
    cleanup();

    const addMeta = (attrs) => {
      const el = document.createElement("meta");
      Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
      el.setAttribute("data-ebs-home", "1");
      head.appendChild(el);
    };

    const addLink = (attrs) => {
      const el = document.createElement("link");
      Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
      el.setAttribute("data-ebs-home", "1");
      head.appendChild(el);
    };

    addLink({ rel: "canonical", href: brand.pageUrl });
    addMeta({ name: "description", content: seo.description });
    addMeta({ name: "keywords", content: seo.keywords });

    addMeta({ property: "og:type", content: "website" });
    addMeta({ property: "og:title", content: seo.title });
    addMeta({ property: "og:description", content: seo.description });
    addMeta({ property: "og:url", content: brand.pageUrl });

    addMeta({ name: "twitter:card", content: "summary_large_image" });
    addMeta({ name: "twitter:title", content: seo.title });
    addMeta({ name: "twitter:description", content: seo.description });

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify(schemaMarkup);
    script.setAttribute("data-ebs-home", "1");
    head.appendChild(script);

    return () => {
      cleanup();
      document.title = prevTitle;
    };
  }, [brand, seo, schemaMarkup]);

  // ===================== SLIDES =====================
  const slides = useMemo(
    () => [
      {
        img: web2,
        title: "TeaSof",
        desc:
          "Purpose-built Tea Garden ERP with Android attendance (Face Recognition) and plucking weight machine integration for higher accuracy and lower manual effort.",
        tags: ["Tea Garden ERP", "Android Attendance", "Automation"],
        cta: { label: "Explore TeaSof", to: "/teasof" },
      },
      {
        img: web,
        title: "HotelSof",
        desc:
          "GST-enabled Hotel / Resort management system with PMS, POS, billing, inventory and accounting — built for smooth operations.",
        tags: ["PMS", "POS Billing", "GST Enabled"],
        cta: { label: "Explore HotelSof", to: "/Hotelsof" },
      },
      {
        img: web1,
        title: "WardMaster",
        desc:
          "Hospital & Nursing Home management system covering OPD/IPD, billing, pharmacy, lab, OT, discharge and reporting — modular & reliable.",
        tags: ["Hospital ERP", "OPD/IPD", "Billing"],
        cta: { label: "Explore WardMaster", to: "/Hospital" },
      },
      {
        img: web3,
        title: "JewSof",
        desc:
          "Jewellery software with barcode/QR + GST features to manage orders, billing, stock and karigar workflows.",
        tags: ["Barcode/QR", "GST", "Stock Control"],
        cta: { label: "Explore JewSof", to: "/jewsof" },
      },
      {
        img: web4,
        title: "RestaurSof",
        desc:
          "Restaurant software for systematic operations: order taking, KOT/BOT, billing, inventory control and reports.",
        tags: ["Restaurant POS", "Inventory", "Reports"],
        cta: { label: "Explore Restaurant", to: "/restaurant" },
      },
    ],
    []
  );

  // ===================== STYLES =====================
  const styles = {
    page: { background: theme.bg },

    // Top info bar
    topBar: {
      background: "rgba(255,255,255,0.03)",
      borderBottom: `1px solid ${theme.border}`,
      color: theme.text,
      fontSize: 13,
    },
    topBarInner: {
      padding: "10px 0",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      gap: 12,
      flexWrap: "wrap",
    },
    topLink: { color: "#fff", textDecoration: "none", fontWeight: 800 },

    // HERO
    heroImg: {
      height: "82vh",
      objectFit: "cover",
      filter: "contrast(1.05) saturate(1.1)",
    },
    heroOverlay: {
      position: "absolute",
      inset: 0,
      background:
        `radial-gradient(900px 520px at 10% 15%, ${theme.glow2}, transparent 60%),` +
        `radial-gradient(850px 520px at 85% 20%, ${theme.glow1}, transparent 60%),` +
        "linear-gradient(120deg, rgba(11,18,32,0.92) 0%, rgba(11,18,32,0.55) 55%, rgba(255,106,0,0.18) 100%)",
    },
    caption: { textAlign: "left", left: "7%", right: "7%", bottom: "12%" },
    glass: {
      maxWidth: 860,
      borderRadius: 18,
      padding: "18px 18px",
      background: "rgba(255,255,255,0.10)",
      border: "1px solid rgba(255,255,255,0.18)",
      backdropFilter: "blur(10px)",
      boxShadow: theme.shadow,
    },
    heroKicker: {
      display: "inline-flex",
      alignItems: "center",
      gap: 10,
      padding: "9px 12px",
      borderRadius: 999,
      background: "rgba(255,255,255,0.10)",
      border: "1px solid rgba(255,255,255,0.18)",
      color: "rgba(255,255,255,0.92)",
      fontWeight: 900,
      textTransform: "uppercase",
      letterSpacing: 1,
      fontSize: 12,
      marginBottom: 12,
    },
    heroTitle: {
      fontWeight: 950,
      letterSpacing: "-0.4px",
      marginBottom: 10,
      fontSize: "clamp(2.0rem, 4vw, 3.0rem)",
      color: "#ffffff",
      lineHeight: 1.05,
    },
    heroDesc: { color: "rgba(255,255,255,0.90)", lineHeight: 1.8, marginBottom: 14, fontSize: "1.05rem" },
    heroBadges: { display: "flex", gap: 10, flexWrap: "wrap", marginBottom: 12 },

    // Buttons
    btnPrimary: {
      background: `linear-gradient(90deg, ${theme.accent}, ${theme.accent2})`,
      border: "none",
      fontWeight: 900,
      borderRadius: 14,
      padding: "10px 14px",
    },
    btnGhost: {
      background: "rgba(255,255,255,0.08)",
      border: "1px solid rgba(255,255,255,0.18)",
      color: "#fff",
      fontWeight: 900,
      borderRadius: 14,
      padding: "10px 14px",
    },

    // Announcement strip
    strip: {
      background:
        "linear-gradient(90deg, rgba(255,106,0,0.18), rgba(255,255,255,0.02), rgba(255,106,0,0.12))",
      borderTop: "1px solid rgba(255,255,255,0.08)",
      borderBottom: "1px solid rgba(255,255,255,0.08)",
    },
    marquee: { color: "rgba(255,255,255,0.92)", fontWeight: 800, padding: "10px 0", letterSpacing: "0.2px" },

    // Sections
    section: { padding: "56px 0", background: theme.bg },
    sectionAlt: {
      padding: "56px 0",
      background:
        "radial-gradient(900px 450px at 10% 10%, rgba(255,106,0,0.18), transparent 60%), linear-gradient(180deg, #0b1220 0%, #0a1020 100%)",
      borderTop: "1px solid rgba(255,255,255,0.06)",
      borderBottom: "1px solid rgba(255,255,255,0.06)",
    },
    h2: { color: "#fff", fontWeight: 950, letterSpacing: "-0.3px", marginBottom: 8 },
    p: { color: theme.text, lineHeight: 1.9, textAlign: "justify", marginBottom: 0 },
    sub: { color: theme.muted, lineHeight: 1.8, marginTop: 8 },

    divider: {
      width: 72,
      height: 4,
      borderRadius: 20,
      background: "linear-gradient(90deg, #ff6a00, #ffd6a6)",
      margin: "12px 0 18px 0",
    },

    // Cards
    card: {
      borderRadius: 18,
      border: `1px solid ${theme.border}`,
      background: theme.surface,
      boxShadow: theme.softShadow,
    },
    cardBody: { padding: 18 },
    cardTitle: { color: "#fff", fontWeight: 950, marginBottom: 10, letterSpacing: "-0.2px" },
    cardText: { color: theme.text, lineHeight: 1.85, marginBottom: 0 },

    // Media
    mediaBox: {
      borderRadius: 18,
      overflow: "hidden",
      border: `1px solid ${theme.border}`,
      boxShadow: theme.shadow,
      background: "rgba(255,255,255,0.04)",
      padding: 12,
    },
    mediaImg: { width: "100%", height: "auto", objectFit: "contain", borderRadius: 14 },

    // Stats
    statNum: { color: "#fff", fontWeight: 950, fontSize: "1.6rem", marginBottom: 2 },
    statLabel: { color: theme.muted, marginBottom: 0, fontWeight: 800 },

    // Product grid cards
    productCard: {
      borderRadius: 18,
      border: `1px solid ${theme.border}`,
      background: "rgba(255,255,255,0.06)",
      boxShadow: theme.softShadow,
      overflow: "hidden",
      height: "100%",
    },
    productImg: { width: "100%", height: 170, objectFit: "cover", filter: "contrast(1.05) saturate(1.05)" },
    productBody: { padding: 16 },
    productTitle: { color: "#fff", fontWeight: 950, marginBottom: 8, letterSpacing: "-0.2px" },
    productDesc: { color: theme.text, lineHeight: 1.75, marginBottom: 12, fontSize: 14 },

    // CTA
    cta: {
      borderRadius: 22,
      border: `1px solid ${theme.border}`,
      background:
        "radial-gradient(900px 520px at 20% 20%, rgba(56,189,248,0.15), transparent 60%)," +
        "radial-gradient(850px 520px at 80% 20%, rgba(255,106,0,0.20), transparent 60%)," +
        "linear-gradient(180deg, rgba(255,255,255,0.06), rgba(255,255,255,0.03))",
      boxShadow: theme.shadow,
      padding: 22,
    },
  };

  // ===================== UI =====================
  return (
    <div style={styles.page}>
      {/* TOP INFO STRIP */}
      <div style={styles.topBar}>
        <Container>
          <div style={styles.topBarInner}>
            <div className="d-flex gap-3 flex-wrap">
              <span>
                Sales:{" "}
                <a style={styles.topLink} href={`tel:${brand.salesPhone.replace(/\s/g, "")}`}>
                  {brand.salesPhone}
                </a>
              </span>
              <span>
                Email:{" "}
                <a style={styles.topLink} href={`mailto:${brand.email}`}>
                  {brand.email}
                </a>
              </span>
            </div>
            <div style={{ fontWeight: 900, color: "rgba(255,255,255,0.85)" }}>GSTIN: {brand.gst}</div>
          </div>
        </Container>
      </div>

      {/* HERO / CAROUSEL */}
      <Container fluid className="px-0">
        <Row className="g-0">
          <Col sm={12}>
            <Carousel indicators controls fade interval={4500}>
              {slides.map((s, idx) => (
                <Carousel.Item key={idx} style={{ position: "relative" }}>
                  <img className="d-block w-100" src={s.img} alt={`${s.title} software`} style={styles.heroImg} />
                  <div style={styles.heroOverlay} />
                  <Carousel.Caption style={styles.caption}>
                    <div style={styles.glass}>
                      <div style={styles.heroKicker}>Industry Software • ERP • GST • POS</div>

                      <div style={styles.heroBadges}>
                        {s.tags.map((t) => (
                          <Badge
                            key={t}
                            bg="light"
                            style={{
                              color: "#0b1220",
                              fontWeight: 950,
                              padding: "8px 10px",
                              borderRadius: 999,
                            }}
                          >
                            {t}
                          </Badge>
                        ))}
                      </div>

                      <h1 style={styles.heroTitle}>{s.title}</h1>
                      <p style={styles.heroDesc}>{s.desc}</p>

                      <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
                        <Button as={Link} to={s.cta.to} style={styles.btnPrimary}>
                          {s.cta.label}
                        </Button>
                        <Button as={Link} to="/Product" style={styles.btnGhost}>
                          View Products
                        </Button>
                        <Button as={Link} to="/request-demo" style={styles.btnGhost}>
                          Request Demo
                        </Button>
                      </div>
                    </div>
                  </Carousel.Caption>
                </Carousel.Item>
              ))}
            </Carousel>
          </Col>
        </Row>

        {/* ANNOUNCEMENT STRIP */}
        <div style={styles.strip}>
          <marquee style={styles.marquee}>
            TeaSof Android Attendance + Plucking Weight Machine Integration • GST Enabled Hotel & Restaurant Software •
            WardMaster Hospital Management System • JewSof Barcode/QR + GST • Retail POS & Inventory
          </marquee>
        </div>
      </Container>

      {/* SECTION: ABOUT */}
      <div style={styles.section}>
        <Container>
          <Row className="align-items-center g-4">
            <Col lg={6}>
              <h2 style={styles.h2}>Business Software Development</h2>
              <div style={styles.divider} />
              <p style={styles.p}>
                Based in Siliguri, West Bengal (India), <b>EBS SOFTWARE SOLUTION</b> builds practical software that
                improves accuracy, speeds up operations and strengthens business control. We deliver industry-specific
                ERP and billing systems with GST-ready workflows, reporting and day-to-day usability.
              </p>
              <p style={styles.sub}>
                Services include implementation, training, customization, upgrades and ongoing support.
              </p>

              <Row className="g-3 mt-3">
                <Col md={4}>
                  <Card style={styles.card}>
                    <Card.Body style={styles.cardBody}>
                      <div style={styles.statNum}>ERP</div>
                      <p style={styles.statLabel}>Automation</p>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={4}>
                  <Card style={styles.card}>
                    <Card.Body style={styles.cardBody}>
                      <div style={styles.statNum}>GST</div>
                      <p style={styles.statLabel}>Compliance</p>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={4}>
                  <Card style={styles.card}>
                    <Card.Body style={styles.cardBody}>
                      <div style={styles.statNum}>Support</div>
                      <p style={styles.statLabel}>Training + Help</p>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>

              <div className="mt-4 d-flex gap-2 flex-wrap">
                <Button as={Link} to="/contact-sales" style={styles.btnPrimary}>
                  Contact Sales
                </Button>
                <Button as={Link} to="/custom" style={styles.btnGhost}>
                  Customize Software
                </Button>
              </div>
            </Col>

            <Col lg={6}>
              <div style={styles.mediaBox}>
                <img src={web5} alt="EBS software dashboard preview" style={styles.mediaImg} />
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* SECTION: PRODUCTS GRID */}
      <div style={styles.sectionAlt}>
        <Container>
          <Row className="mb-3">
            <Col lg={8}>
              <h2 style={styles.h2}>Industry Solutions</h2>
              <div style={styles.divider} />
              <p style={{ ...styles.p, marginBottom: 0 }}>
                Choose a product page to explore modules, features and demo options.
              </p>
            </Col>
          </Row>

          <Row className="g-3">
            {[
              { img: web2, title: "TeaSof", desc: "Tea Garden ERP with Android attendance & weighment integration.", to: "/teasof" },
              { img: web, title: "HotelSof", desc: "PMS + POS + GST billing + inventory + accounting.", to: "/Hotelsof" },
              { img: web1, title: "WardMaster", desc: "OPD/IPD, billing, pharmacy, lab, OT & MIS reports.", to: "/Hospital" },
              { img: web3, title: "JewSof", desc: "GST billing, stock control, orders, karigar and barcode/QR.", to: "/jewsof" },
              { img: web4, title: "RestaurSof", desc: "Restaurant POS, KOT/BOT, inventory and reports.", to: "/restaurant" },
            ].map((p) => (
              <Col md={6} lg={4} key={p.title}>
                <Card style={styles.productCard} className="h-100">
                  <img src={p.img} alt={`${p.title} preview`} style={styles.productImg} />
                  <Card.Body style={styles.productBody}>
                    <div style={styles.productTitle}>{p.title}</div>
                    <div style={styles.productDesc}>{p.desc}</div>
                    <Button as={Link} to={p.to} style={styles.btnGhost}>
                      Learn More
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </div>

      {/* SECTION: IT INFRA */}
      <div style={styles.section}>
        <Container>
          <Row className="align-items-center g-4">
            <Col lg={6} className="order-lg-2">
              <h2 style={styles.h2}>IT Infrastructure Ready</h2>
              <div style={styles.divider} />
              <p style={styles.p}>
                We help organizations run stable operations with systems designed for performance and scalability.
                Integration-friendly reporting, reliable workflows and practical implementation help ensure business
                continuity.
              </p>

              <Row className="g-3 mt-3">
                <Col md={6}>
                  <Card style={styles.card}>
                    <Card.Body style={styles.cardBody}>
                      <div style={styles.cardTitle}>Holistic Solutions</div>
                      <p style={styles.cardText}>
                        Practical integration across departments with security-minded design.
                      </p>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={6}>
                  <Card style={styles.card}>
                    <Card.Body style={styles.cardBody}>
                      <div style={styles.cardTitle}>Scalable by Design</div>
                      <p style={styles.cardText}>
                        Works for small businesses to enterprise operations with expansion options.
                      </p>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Col>

            <Col lg={6} className="order-lg-1">
              <div style={styles.mediaBox}>
                <img src={web6} alt="IT infrastructure software preview" style={styles.mediaImg} />
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* SECTION: SERVICES + CTA */}
      <div style={styles.sectionAlt}>
        <Container>
          <Row className="mb-3 text-center">
            <Col lg={12}>
              <h2 style={styles.h2}>Implementation & Support</h2>
              <div style={{ ...styles.divider, margin: "12px auto 18px auto" }} />
              <p style={{ color: theme.muted, maxWidth: 900, margin: "0 auto" }}>
                We ensure adoption with structured implementation, training, customization and ongoing support.
              </p>
            </Col>
          </Row>

          <Row className="g-3 mt-2">
            {[
              "Installation & Implementation",
              "Project Planning",
              "Training for Staff & Management",
              "Customization & New Development",
              "Upgrades & Support",
              "Scheduled Training Courses",
            ].map((t) => (
              <Col md={6} lg={4} key={t}>
                <Card style={styles.card} className="h-100">
                  <Card.Body style={styles.cardBody}>
                    <div style={styles.cardTitle}>{t}</div>
                    <p style={styles.cardText}>A clear delivery process for predictable outcomes and consistent quality.</p>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>

          <Row className="mt-4">
            <Col lg={12}>
              <div style={styles.cta}>
                <Row className="align-items-center g-3">
                  <Col lg={8}>
                    <h3 style={{ color: "#fff", fontWeight: 950, marginBottom: 8, letterSpacing: "-0.2px" }}>
                      Talk to Sales / Request a Demo
                    </h3>
                    <p style={{ color: theme.text, marginBottom: 0, lineHeight: 1.8 }}>
                      Call{" "}
                      <a
                        href={`tel:${brand.salesPhone.replace(/\s/g, "")}`}
                        style={{ color: "#fff", fontWeight: 950, textDecoration: "underline" }}
                      >
                        {brand.salesPhone}
                      </a>{" "}
                      or submit your requirements and our team will connect with you.
                    </p>
                  </Col>
                  <Col lg={4} className="d-flex gap-2 justify-content-lg-end flex-wrap">
                    <Button as={Link} to="/request-demo" style={styles.btnPrimary}>
                      Request Demo
                    </Button>
                    <Button as={Link} to="/contact-sales" style={styles.btnGhost}>
                      Contact Sales
                    </Button>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default Home;
